/**
 * Flattens the data.
 *
 * Greenhouse data is deeply nested making it complicated to manipulate for our
 * use case (filtering).
 *
 * Original structure:
 *   offices
 *   |_ departments
 *      |_ jobs
 *
 * Output:
 *   jobs
 *   |_ department
 *   |_ office
 */
export const parseData = data => {
  const result = [];

  data.offices.forEach(office => {
    const { departments, ...officeWithoutDepartments } = office; // eslint-disable-line

    office.departments.forEach(department => {
      const { jobs, ...departmentWithoutJobs } = department; // eslint-disable-line

      department.jobs.forEach(job => {
        result.push({
          ...job,
          office: officeWithoutDepartments,
          department: departmentWithoutJobs,
        });
      });
    });
  });

  return result;
};
